<tabbed-detail-base [tabs]="navTabs()" [(activeTabIndex)]="activeTabIndex">
  <span heading>{{ "ServiceElement.ConnectedPorts" | translate }}</span>

  @if (activeFirewallInterconnect(); as interconnect) {
    <l3vpn-firewall-interconnect-panel tab-content [interconnect]="interconnect" />
  }
  @if (activeSap(); as sap) {
    <l3vpn-sap-panel tab-content [sap]="sap" />
  }
</tabbed-detail-base>
